import { add, qs, qsa, remove } from "@fluorescent/dom";
import { ProductForm } from "@shopify/theme-product-form";
import Delegate from "ftdomdelegate";

import { cart, formatMoney } from "@/neon";
import { emit } from "@/neon/events";
import { dispatchCustomEvent, CustomEvents } from "@/lib/dispatch-custom-event";
import OptionButtons from "@/lib/option-buttons";


const selectors = {
  addToCart: "[data-add-to-cart]",
  price: "[data-price]",
  comparePrice: "[data-compare-price]",
};

const getProductMarkup = handle => cb =>
  fetch(`${window.theme.routes.products}/${handle}?view=quick`)
    .then(res => res.text())
    .then(data => cb(data))
    .catch(err => console.log(err.message));

export default function () {
  const delegate = new Delegate(document.body);
  delegate.on("click", "button[data-quick-add]", handleClick);

  function handleClick(_, target) {
    const { quickAdd: handle } = target.dataset;

    // Open and show loading state
    emit("cart:configureLoading");

    // Fetch markup and send to quick cart
    const product = getProductMarkup(handle);
    product(html => emit("cart:configureReady", null, { html, handle }));
  }
}

export function handleForm(data, scope) {
  const buyButton = qs("[data-add-to-cart]", scope);
  const errorMessage = qs("[data-error-message]", scope);
  const optionButtons = OptionButtons(qsa("[data-option-buttons]", scope));

  const productForm = new ProductForm(qs("[data-product-form]", scope), data, {
    onOptionChange: ({ dataset: { variant } }) => {
      // Update prices
      const price = qsa(selectors.price, scope);
      const comparePrice = qsa(selectors.comparePrice, scope);

      dispatchCustomEvent(CustomEvents.productVariantChange, {
        variant: variant,
      });
      if (variant) {
        price.forEach(el => (el.innerHTML = formatMoney(variant.price)));
        comparePrice.forEach(
          el =>
            (el.innerHTML =
              variant.compare_at_price > variant.price
                ? formatMoney(variant.compare_at_price)
                : "")
        );
      }

      // Update add to cart button
      const text = qs("[data-add-to-cart-text]", buyButton);
      const { langAvailable, langUnavailable, langSoldOut } = buyButton.dataset;

      if (!variant) {
        buyButton.setAttribute("disabled", "disabled");
        text.textContent = langUnavailable;
      } else if (variant.available) {
        buyButton.removeAttribute("disabled");
        text.textContent = langAvailable;
      } else {
        buyButton.setAttribute("disabled", "disabled");
        text.textContent = langSoldOut;
      }
    },

    onFormSubmit: e => {
      e.preventDefault();
      add(buyButton, "loading");
      remove(errorMessage, "visible");

      cart
        .addItem(productForm.element)
        .then(({ item }) => {
          remove(buyButton, "loading");
          emit("cart:open", null, { flash: item.variant_id });
        })
        .catch(error => {
          remove(buyButton, "loading");
          add(errorMessage, "visible");
          errorMessage.innerText = error.message;
        });
    },
  });
}
